document.addEventListener("focusin", (event) => {
	// if (event.target.closest("input.datepicker")) {
	// 	const target_field = event.target.closest("input.datepicker"),
	// 		dropdown = target_field.nextElementSibling
	// 	UIkit.dropdown(dropdown).show()
	// 	datepicking(target_field)
	// }
})

window.datepicking = (target_field) => {
	moment.locale("de")

	//Dropdown
	const dropdown = target_field.nextElementSibling

	// HTML-Elemente erstellen
	const date_picker_element = document.createElement("div")
	date_picker_element.classList.add("date_picker")
	const dates_element = document.createElement("div")
	dates_element.classList.add("dates")
	const month_element = document.createElement("div")
	month_element.classList.add("month")
	const prev_mth_element = document.createElement("div")
	prev_mth_element.classList.add("prev_mth", "arrows")
	prev_mth_element.innerHTML = svgPfeilLinks
	const next_mth_element = document.createElement("div")
	next_mth_element.classList.add("next_mth", "arrows")
	next_mth_element.innerHTML = svgPfeilRechts
	const mth_element = document.createElement("div")
	mth_element.classList.add("mth")
	const weekdays_element = document.createElement("div")
	weekdays_element.classList.add("weekdays")
	const calendarweek_element = document.createElement("div")
	calendarweek_element.classList.add("calendarweek")
	const days_element = document.createElement("div")
	days_element.classList.add("days")

	// Node-Tree
	dropdown.innerHTML = ""
	dropdown.append(date_picker_element)
	date_picker_element.append(dates_element)
	dates_element.append(month_element, weekdays_element, calendarweek_element, days_element)
	month_element.append(prev_mth_element, mth_element, next_mth_element)

	// Sonstige
	const weekdays = ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"]
	let date = moment()
	if (target_field.value != "") {
		date = moment(target_field.value, "DD.MM.YYYY")
	}
	let selectedDate = date

	// Alle Elemente mit Inhalt befuellen
	mth_element.textContent = date.format("MMMM YYYY")
	target_field.value = date.format("DD.MM.YYYY")
	populateWeekdays()
	populateDates()

	// Event-Listener fuer die Pfeile
	next_mth_element.addEventListener("click", goToNextMonth)
	prev_mth_element.addEventListener("click", goToPrevMonth)

	// ############################################################################
	// Befuellen der einzelnen Tage
	// ############################################################################
	function populateDates() {
		days_element.innerHTML = ""
		calendarweek_element.innerHTML = ""

		// Durchlaufvariable Tag -> Start = Monatsanfang + Wochenanfang
		let day_i = moment(mth_element.textContent, "MMMM YYYY")
		day_i.startOf("month").startOf("week").startOf("day")

		for (let i = 0; i < 42; i++) {
			// Kalenderwoche
			if ((i + 7) % 7 == 0) {
				const kw = document.createElement("div")
				kw.classList.add("kw")
				kw.textContent = day_i.isoWeek()
				calendarweek_element.append(kw)
			}

			const day_element = document.createElement("div")
			day_element.classList.add("day", "uk-dropdown-close")
			day_element.textContent = day_i.format("DD")
			day_element.dataset.date = day_i.format("DD.MM.YYYY")

			// Tage, die zu einem anderen Monat gehören, heller färben
			if (day_i.format("MMMM") != moment(mth_element.textContent, "MMMM YYYY").format("MMMM")) {
				day_element.classList.add("othermonth")
			}

			// Ausgewählten Tag einfaerben
			if (selectedDate.format("DD.MM.YYYY") == day_i.format("DD.MM.YYYY")) {
				day_element.classList.add("selected")
			}

			// Event-Listener
			day_element.addEventListener("click", updateSelectedDate)

			// Element hinzufuegen und Tag erhoehen
			days_element.appendChild(day_element)
			day_i = day_i.add("1", "d")
		}
	}
	// ############################################################################
	// Funktionen durch Klicken auf die Pfeile
	// ############################################################################
	function goToNextMonth() {
		const element = moment(mth_element.textContent, "MMMM YYYY")
		const nextMonth = element.add(1, "M")
		mth_element.textContent = nextMonth.format("MMMM YYYY")
		populateDates()
	}

	function goToPrevMonth() {
		const element = moment(mth_element.textContent, "MMMM YYYY")
		const prevMonth = element.subtract(1, "M")
		mth_element.textContent = prevMonth.format("MMMM YYYY")
		populateDates()
	}

	// ############################################################################
	// Befuellen der Wochentage
	// ############################################################################
	function populateWeekdays() {
		weekdays.forEach((wd) => {
			const weekday_element = document.createElement("div")
			weekday_element.classList.add("weekday")
			weekday_element.textContent = wd
			weekdays_element.appendChild(weekday_element)
		})
	}

	// ############################################################################
	// Funktion durch Klicken auf einen Tag
	// ############################################################################
	function updateSelectedDate() {
		// Alle Tage entfaerben
		const days = days_element.querySelectorAll(".day")
		days.forEach((d) => {
			d.classList.remove("selected")
		})

		// Ausgewählten Tag einfaerben
		this.classList.add("selected")

		// Selected Date aendern
		selectedDate = moment(this.dataset.date, "DD.MM.YYYY")

		// Selected Date anzeigen und Filter auslösen
		target_field.value = selectedDate.format("DD.MM.YYYY")
		target_field.dispatchEvent(new Event("change", { bubbles: true }))
	}
}
